import validator from 'validator';
import _ from 'lodash';

const NOT_VALID_EMAIL_MESSAGE = 'This email address is invalid.';
const SAME_EMAIL_AS_USER = 'You cannot use your own email to create an influencer.';
const EMAIL_USED_BY_ORG_USER_MESSAGE = 'Someone in your organisation is already using this email address.';
const INFLUENCER_EXISTS_IN_DB = 'An influencer from your database is already using this email address.';

const getFilter = ids => {
  if (_.size(ids)) {
    return {
      filter: {
        influencer: _.join(ids, ','),
      },
      include: ['influencer'],
    };
  }
  return {
    include: ['influencer'],
  };
};

export const doesInfluencerExistInOrganisation = (value, organisationId, jsonAPIClient, influencerId) =>
  jsonAPIClient.find('influencer', {
    filter: {
      email: value,
    },
  })
    .then(res => {
      const influencerIds = _.size(res) > 0 ? _.map(res, item => item.toJSON().id) : [];
      return jsonAPIClient.find('influencerLink', getFilter(influencerIds));
    })
    .then(links => {
      const records = _.reject(
        _.map(links, link => link.toJSONTree()),
        ({ influencer }) => influencer.id === influencerId,
      );


      const influencerAlreadyExists = !_.isUndefined(_.find(records, record => {
        const { influencer: { email: influencerEmail }, organisation } = record;
        return influencerEmail === value && organisation.id === organisationId;
      }));

      return influencerAlreadyExists;
    });

export const fetchOrganizationEmails = ({
  userInfo: { organisationId },
  jsonAPIClient,
}) => jsonAPIClient.find('users', {
  filter: {
    organisation: organisationId,
  },
})
  .then(res => _.map(res, item => item.get('email')));


export const validateEmail = ({
  value,
  organisationEmails,
  userInfo: {
    organisationId,
    email,
  },
  jsonAPIClient,
  influencerId,
}) => {
  if (_.isEmpty(value)) {
    return Promise.resolve({ isValid: true });
  }
  if (!validator.isEmail(value)) {
    return Promise.resolve({ isValid: false, message: NOT_VALID_EMAIL_MESSAGE });
  }
  if (value === email) {
    return Promise.resolve({ isValid: false, message: SAME_EMAIL_AS_USER });
  }
  if (_.includes(organisationEmails, value)) {
    return Promise.resolve({ isValid: false, message: EMAIL_USED_BY_ORG_USER_MESSAGE });
  }
  return doesInfluencerExistInOrganisation(value, organisationId, jsonAPIClient, influencerId)
    .then(exists => {
      if (exists) {
        return { isValid: false, message: INFLUENCER_EXISTS_IN_DB };
      }
      return { isValid: true };
    });
};



/** WEBPACK FOOTER **
 ** ./src/utils/influencer-email.js
 **/